module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/axe-112326b42c5e078eb888d8fc2d124436.svg";